import { Line } from "@ant-design/plots";
import { memo, useCallback, useState } from "react";
import { Card, Row, Spin } from "antd";
import { useFetchData } from "./hooks/useFetchData";
import { IntervalSelector } from "../IntervalSelector";
import { useFormattedBalance } from "../../hooks/useFormattedBalance";
import { useDoubleLineChartConfig } from "../../hooks/useDoubleLineChartConfig";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../../lib/constants";
import { DefaultLegend } from "../DefaultLegend";

type ImpoundBalanceProps = {
  totalImpound: number | null;
  closedImpounds: number | null;
  isDataLoading: boolean;
  isRecalculated: boolean;
};

const ImpoundBalance = ({
  totalImpound,
  closedImpounds,
  isDataLoading,
  isRecalculated,
}: ImpoundBalanceProps) => {
  const [granularity, setGranularity] = useState<number>(2);

  const { data, isLoading } = useFetchData(isRecalculated, granularity);

  const { getFormattedBalance } = useFormattedBalance();

  const getColor = useCallback(({ type }: { type: string }): string => {
    return type === "All" ? CHART_PAID_OFF : CHART_DEFAULT;
  }, []);

  const { config } = useDoubleLineChartConfig(data, getColor, true);

  return (
    <Card className="dashboard-card top">
      <Row className="justify-space-between align-center">
        <p className="text my-0">Impound Balance</p>
        <IntervalSelector
          value={granularity}
          onSelect={setGranularity}
          removeDaily
        />
      </Row>
      <Row className="d-block h-100">
        {!isLoading && !isDataLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">{getFormattedBalance(totalImpound)}</h3>
                <p className="my-0 text-sm title">all accounts</p>
              </Row>
              <Row className="d-block">
                <h3 className="h h3">{getFormattedBalance(closedImpounds)}</h3>
                <p className="my-0 text-sm title">closed accounts</p>
              </Row>
            </Row>

            <Line {...config} />

            <DefaultLegend first="All Accounts" second="Closed Accounts" />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};

export default memo(ImpoundBalance);
